import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getEnglishFooterList } from "../../../services/footer/footer.service";
import styles from "./FooterEN.module.css";

const FooterEN = () => {
  const location = useLocation();
  let [footer, setFooter] = useState([]);
  let [isEnglish, setIsEnglish] = useState(false);
  useEffect(() => {
    if (!isEnglish) {
      getEnglishFooterList().then(({ data }) => {
        setFooter(data.data);
      });
    }
  }, [isEnglish]);
  useEffect(() => {
    if (window.location.href.indexOf("/en") >= 0) {
      setIsEnglish(true);
    } else {
      setIsEnglish(false);
    }
  }, [location]);
  return (
    <footer className={styles.footer}>
      <div className={styles.footerPattern} />
      <div className={"container"}>
        <div className={styles.dFlex}>
          {footer.map((item, key) => (
            <div
              key={key + "-footer-index"}
              className={`${styles.flexOne} ${styles.footerHeading}`}
            >
              <Link
                className={styles.headingLink}
                to={{ pathname: item.destination_url }}
                target={
                  item.destination_url &&
                  item.destination_url.startsWith("http")
                    ? "_blank"
                    : null
                }
              >
                {item.title}
              </Link>
              {Array.isArray(item.children) && item.children.length > 0 ? (
                <ul className={styles.subChilds}>
                  {item.children.map((child, key) => (
                    <li key={key + 2000 + "-subchild-item"}>
                      <i className={"fa fa-angle-right"}></i>{" "}
                      {
                        <Link
                          className={`${styles.headingLink}`}
                          to={{ pathname: child.destination_url }}
                          target={
                            child.destination_url &&
                            child.destination_url.startsWith("http")
                              ? "_blank"
                              : null
                          }
                        >
                          {child.title}
                        </Link>
                      }
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          ))}
          <div className={`${styles.flexOne} ${styles.footerHeading}`}>
            <div className={styles.logoFooter}>
              <img
                src={"/assets/image/logo-header-reverse.png"}
                alt="لوگوی شرکت"
              />
            </div>
            <ul className={`${styles.subChilds} ${styles.contactUsSeparator}`}>
              <li className={styles.contactUsForm}>
                <i className="fa fa-phone"></i>
                <span>Telephone : 27370</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-fax"></i>
                <span> Fax : 22221022 and 79-27377274</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-address-card"></i>
                <span>Postal Code : 1545654311</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-envelope"></i>
                <span> Email : Info@isc.co.ir</span>
              </li>
              <li className={styles.contactUsForm}>
                <i className="fa fa-map-pin"></i>
                <span>
                  Marjan Apartment, Block 6, Madad Karan and Khajavi
                  Intersection, Madar Square, Mirdamad St, Tehran
                </span>
              </li>
            </ul>
          </div>
          <div className={"clearfix"}></div>
        </div>
      </div>
      <div className={`${styles.footerBottom}`}>
        All Rights Are Reserved to Informatic Systems Corporation.
      </div>
    </footer>
  );
};

export default FooterEN;
